// Formatting for the audience builder's targeting controls. Its own module rather than an export from
// `TargetingField`, because both the typeahead and the suggestion strip read it — and a helper exported from a
// component file trips `react-refresh/only-export-components` for exactly that reason (the `rosterFormat` /
// `bestTimeFormat` precedent).

/**
 * Audience sizes read "1.2M" / "340k" — the reference's own formatting, and the reason the size is worth
 * showing at all: it is how you tell a broad interest from a dead one.
 *
 * ONE authority, because the two surfaces render the SAME vendor field. Two roundings of one number is the
 * `holdCountdown` family — they agree until they meet a boundary, and then the same interest reads two ways
 * depending on which control you found it in.
 */
export function audienceLabel(n: number | null | undefined): string {
  if (!n || n <= 0) return "";
  if (n >= 1e9) return `${(n / 1e9).toFixed(1).replace(/\.0$/, "")}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1).replace(/\.0$/, "")}M`;
  if (n >= 1e3) return `${Math.round(n / 1e3)}k`;
  return String(n);
}
